import { ButtonBase, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
export const Item = ({ label, route }) => (React.createElement(ButtonBase, { LinkComponent: Link, href: route, sx: { width: "fit-content", pt: 0.1, pb: 0.35, px: 1.25, borderRadius: 1 } },
    React.createElement(Typography, { variant: "h2", textAlign: "center", sx: { py: 0 } }, label)));
//# sourceMappingURL=item.js.map